import { WardApi } from '@/app/wards/wardApi';

const state = {
    organizations: [],
    primary_organizations: [],
    aux_organizations: [],
    all_organizations: [],
    active_organizations: [],
    disabled_organizations: [],
    selectedSearchOrgFilter : null,
}

const getters = {
    selectedSearchOrgState: state => state.selectedSearchOrgFilter,
    organizations: state => state.organizations,
    all_organizations: state => state.all_organizations,
    aux_organizations: state => state.aux_organizations,
    primary_organizations: state => state.primary_organizations
}

const mutations = {
    saveOrganizations(state, payload) {
        state.organizations = payload.org_list;
        // clear lists before loading
        state.primary_organizations = [];
        state.aux_organizations = [];
        state.all_organizations = [];
        state.active_organizations = [];
        state.disabled_organizations = [];

        state.organizations.forEach(x=>{
            // push everything
            state.all_organizations.push({
                value: x.org_code,
                text: x.org_name,
                message_languages: x.message_languages,
                default_language: x.greeting_language,
                disabled: x.disabled,
                composite_orgs: x.composite_orgs,
                org_code: x.org_code,
                primary: x.primary,
                composite_orgs_expanded: x.composite_orgs_expanded

            });
            // push disabled/disabled
            if(x.disabled){
                state.disabled_organizations.push({
                    value: x.org_code,
                    text: x.org_name,
                    message_languages: x.message_languages,
                    default_language: x.greeting_language,
                    disabled: x.disabled,
                    composite_orgs: x.composite_orgs,
                });
            }else{
                state.active_organizations.push({
                    value: x.org_code,
                    text: x.org_name,
                    message_languages: x.message_languages,
                    default_language: x.greeting_language,
                    disabled: x.disabled,
                    composite_orgs: x.composite_orgs

                });
            }
            if(x.primary){
                state.primary_organizations.push({
                    value: x.org_code,
                    text: x.org_name,
                    message_languages: x.message_languages,
                    default_language: x.greeting_language,
                    disabled: x.disabled,
                    composite_orgs: x.composite_orgs
                })
            }else{
                state.aux_organizations.push({
                    value: x.org_code,
                    text: x.org_name,
                    message_languages: x.message_languages,
                    default_language: x.greeting_language,
                    disabled: x.disabled,
                    composite_orgs: x.composite_orgs
                })
            }
        });

        // sort lists
        state.all_organizations.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
        state.active_organizations.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
        state.disabled_organizations.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
        state.primary_organizations.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
        state.aux_organizations.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));

    },
    updateSearchOrgFilter(state, currentOrg) {
        state.selectedSearchOrgFilter =  currentOrg
    },
    clearSearchOrgFilter(state) {
        state.selectedSearchOrgFilter = null;
    },
}

const actions = {
    async loadOrganizations({commit, state}, wardId) {
        const { data } = await WardApi.getWardOrganizations(wardId);
        commit('saveOrganizations', data);
    },
    saveSearchOrgFilter({commit, state}, selectedOrg)
    {
        commit('updateSearchOrgFilter', selectedOrg);
    },
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
};
